// HR Manager — admin-like surface with a specific set of pages hidden:
// Analytics, Inbox, Shipping Dashboard, POS, Field Sales Form, and the whole
// Operations section (Scanner, Packing Batches, Mark Returns). Route access is
// admin-equivalent (access.js ROLE_GROUPS) with those pages blocked via
// meta.blockedRoles. Settings is replaced by a scoped /staff page that exposes
// only the Users section (create tele sales staff). Keep in sync with the
// blockedRoles set in router/index.js.
export const HR_MANAGER_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Tele Sales', href: '/telesales', icon: 'cilPhone' },
  { slug: 'link', name: 'Order Form', href: '/orderform', icon: 'cilPencil' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
  { slug: 'link', name: 'MAP Bulk', href: '/mapbulk', icon: 'cilLayers' },
  { slug: 'link', name: 'MVP Bulk', href: '/mvpbulk', icon: 'cilCopy' },

  { slug: 'title', name: 'Attendance' },
  {
    slug: 'dropdown',
    name: 'Attendance',
    icon: 'cilClock',
    elements: [
      { slug: 'link', name: 'Hours Report', href: '/attendance/hours', icon: 'cilCalendar' },
      { slug: 'link', name: 'Payroll Insights', href: '/attendance/monthly', icon: 'cilCash' },
      { slug: 'link', name: 'Coimbatore Branch', href: '/attendance/hours?device=a4:d5:c2:40:e8:2c', icon: 'cilBuilding' },
      { slug: 'link', name: 'Devices', href: '/attendance/devices', icon: 'cilDevices' },
      { slug: 'link', name: 'PIN → Staff Mapping', href: '/attendance/pins', icon: 'cilFingerprint' },
    ],
  },

  { slug: 'title', name: 'CRM & Calls' },
  {
    slug: 'dropdown',
    name: 'CRM',
    icon: 'cilPeople',
    elements: [
      { slug: 'link', name: 'Customers', href: '/customers', icon: 'cilUser' },
      { slug: 'link', name: 'Tickets', href: '/alltickets', icon: 'cilTicket' },
      { slug: 'link', name: 'Add Priority Number', href: '/addpriority', icon: 'cilFlag' },
    ],
  },
  { slug: 'link', name: 'Call Log', href: '/call_log', icon: 'cilCallIncoming' },
  { slug: 'link', name: 'Field Visits', href: '/fieldvisits', icon: 'cilLocationPin', organisationIds: [1, 4] },
  { slug: 'link', name: 'Call Queue', href: '/callqueue', icon: 'cilCallOutgoing' },
  { slug: 'link', name: 'Call Summary', href: '/callsummary', icon: 'cilChartBar' },
  { slug: 'link', name: 'Graded Follow Ups', href: '/grade_followups', icon: 'cilStar' },

  { slug: 'title', name: 'Incentives' },
  { slug: 'link', name: 'HMS Imports', href: '/hms_imports', icon: 'cilCloudUpload' },
  { slug: 'link', name: 'Incentive Preview', href: '/incentive_preview', icon: 'cilGift' },
  { slug: 'link', name: 'Amazon Care-of', href: '/amazon_care_of', icon: 'cilAmazon' },
  { slug: 'link', name: 'Flipkart Care-of', href: '/flipkart_care_of', icon: 'cilFlipkart' },
  { slug: 'link', name: 'Website Care-of', href: '/website_care_of', icon: 'cilGlobeAlt' },
  { slug: 'link', name: 'Store Sales Care-of', href: '/store_care_of', icon: 'cilBasket' },
  { slug: 'link', name: 'Tele-Sales Accounts', href: '/tele_sales_accounts', icon: 'cilWallet' },
  { slug: 'link', name: 'Telesales Leaderboard', href: '/leaderboard', icon: 'cilCup' },

  { slug: 'title', name: 'Finance & Exports' },
  {
    slug: 'dropdown',
    name: 'Payments',
    icon: 'cilDollar',
    elements: [
      { slug: 'link', name: 'COD Payments', href: '/pendingpayments', icon: 'cilHandCoin' },
      { slug: 'link', name: 'Razorpay Transactions', href: '/razorpay-transactions', icon: 'cilCreditCard' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Exports',
    icon: 'cilShareArrow',
    elements: [
      { slug: 'link', name: 'Tally Export', href: '/tallyexport', icon: 'cilSpreadsheet' },
      { slug: 'link', name: 'Zoho Export', href: '/zohoexport', icon: 'cilFile' },
      { slug: 'link', name: 'Verify Zoho Invoices', href: '/Verifyzohoinvoices', icon: 'cilCheckCircle' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
  { slug: 'link', name: 'Refunds', href: '/refund', icon: 'cilMoneyBack' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },

  { slug: 'title', name: 'Settings' },
  { slug: 'link', name: 'Settings', icon: 'cilSettings', href: '/staff' },
]
